<template>
    <v-flex xs6 sm3 md2 lg1 class="pa-2">
        <v-card class="pointer flexcard" color="light-blue darken-1" height="100%" @click="openModal">
            <v-card-title class="justify-center grow">
                <v-icon color="light-blue lighten-5" class="tile-icon">create_new_folder</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions
                class="pa-3 font-weight-medium text-truncate justify-center light-blue--text text--lighten-5">
                Ajout répertoire
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialog" width="600">
            <v-form ref="form" lazy-validation @submit.prevent.stop="validate">
                <v-card>
                    <v-card-title class="display-1 font-weight-light" primary-title>
                        Ajouter un répertoire
                    </v-card-title>

                    <v-card-text>
                        <v-text-field ref="inputName" v-model="formInputName" label="Nom" required
                                      :rules="formInputNameRules"></v-text-field>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="dialog = false">
                            Annuler
                        </v-btn>
                        <v-btn color="green lighten-2 white--text" :disabled="loading" @click="validate">
                            Enregistrer
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-flex>
</template>

<script>
    import {mapGetters} from "vuex";
    import {DirectoryService} from "../../services/directory.service";

    export default {
        name: "DirectoryAdd",
        data: () => ({
            dialog: false,
            loading: false,
            formInputName: '',
            formInputNameRules: [
                name => !!name || 'Le nom est nécessaire'
            ]
        }),
        computed: {
            ...mapGetters(["currentDirectory"])
        },
        methods: {
            /**
             * Affiche le formulaire
             */
            openModal() {
                this.dialog = true;
                this.$nextTick(this.$refs.inputName.focus);
            },
            /**
             * RAZ formulaire
             */
            resetForm() {
                this.formInputName = '';
                this.dialog = false;
                this.loading = false;
            },
            /**
             * Soumission du formulaire
             */
            validate() {
                if (this.$refs.form.validate()) {
                    this.loading = true;

                    DirectoryService.add({
                        parent: this.currentDirectory.slug,
                        name: this.formInputName
                    }).then((response) => {
                        this.resetForm();
                        this.$router.push({name: 'directory-show', params: {slug: response.data.slug}});
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
